module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "box",
    staticClass: "box",
    class: _vm.classes
  }, [(!_vm.disableHeader) ? _c('div', {
    staticClass: "box-header",
    class: _vm.headerBorder ? 'with-border' : ''
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_vm._t("box-tools"), _vm._v(" "), (_vm.canCollapse && !_vm.collapsed) ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Collapse'),
      expression: "'Collapse'"
    }],
    staticClass: "btn btn-box-tool",
    on: {
      "click": _vm.collapse
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]) : _vm._e(), _vm._v(" "), (_vm.canCollapse && _vm.collapsed) ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Expand'),
      expression: "'Expand'"
    }],
    staticClass: "btn btn-box-tool",
    on: {
      "click": _vm.expand
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e(), _vm._v(" "), (_vm.canClose) ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Close'),
      expression: "'Close'"
    }],
    staticClass: "btn btn-box-tool",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e()], 2), _vm._v(" "), _vm._t("header")], 2) : _vm._e(), _vm._v(" "), (!_vm.disableBody) ? _c('div', {
    ref: "body",
    staticClass: "box-body",
    class: [_vm.collapsed ? 'collapsed' : '', _vm.noPadding ? 'no-padding' : '']
  }, [_vm._t("body")], 2) : _vm._e(), _vm._v(" "), (!_vm.disableFooter) ? _c('div', {
    ref: "footer",
    staticClass: "box-footer"
  }, [_vm._t("footer")], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21d1e990", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d1e990"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utilities/Box.vue
// module id = 2275
// module chunks = 0